/**
 * PlatformTour TOUR_STEPS, ordered list of guided-tour steps.
 * Extracted from PlatformTour.js (Phase 3 refactor, 2026-05-03).
 */
export const TOUR_STEPS = [
  {
    targets: ['[data-testid="isaiah-avatar"]'],
    title: "Welcome to Isaiah's World!",
    message: "Hey there, explorer! Welcome to Isaiah's World, a magical place where kids, parents, and solo explorers of every age learn, play, and create amazing things together! Let me show you around.",
    pose: "waving",
    position: "bottom",
    scrollTo: 0,
  },
  {
    targets: ['[data-testid="nav-learn"]', '[data-testid="world-node-learn"]'],
    mobileTargets: ['[data-testid="world-node-learn"]', '[data-testid="mobile-nav-learn"]'],
    title: "Learning Forest",
    message: "This is the Learning Forest! Click \"Learn\" in the menu or the Learning Forest on the map. You'll find Professor Owl, your friendly AI tutor, plus tons of learning tools and features covering math, reading, science, Spanish, and so much more!",
    pose: "encouraging",
    position: "center-right",
    scrollTo: "world-map",
  },
  {
    targets: ['[data-testid="nav-arcade"]', '[data-testid="world-node-arcade"]'],
    mobileTargets: ['[data-testid="world-node-arcade"]', '[data-testid="mobile-nav-arcade"]'],
    title: "Arcade City",
    message: "Welcome to Arcade City! Click \"Arcade\" up top or Arcade City on the map. We have 25+ games \u2014 chess, puzzles, trivia, word games, and retro classics. Every game earns you Stars!",
    pose: "celebrating",
    position: "center-left",
    scrollTo: "world-map",
  },
  {
    targets: ['[data-testid="nav-adventures"]', '[data-testid="world-node-adventure"]'],
    mobileTargets: ['[data-testid="world-node-adventure"]', '[data-testid="mobile-nav-adventures"]'],
    title: "Adventure Island",
    message: "Adventure Island is where stories come alive! Click \"Adventures\" in the menu or Adventure Island on the map. Our AI Storyteller creates custom illustrated adventures just for you!",
    pose: "idle",
    position: "center",
    scrollTo: "world-map",
  },
  {
    targets: ['[data-testid="nav-create"]', '[data-testid="world-node-art"]'],
    mobileTargets: ['[data-testid="mobile-nav-art-studio"]', '[data-testid="world-node-art"]'],
    title: "Art Studio",
    message: "The Art Studio is my favorite! Tap \"Art Studio\" in the menu or on the map. Draw, create with AI, challenge friends, and build your own art gallery. Get creative!",
    pose: "encouraging",
    position: "center",
    scrollTo: "world-map",
  },
  {
    targets: ['[data-testid="how-it-works"]'],
    title: "How It All Works",
    message: "Here's the whole journey in 4 simple steps. Step 1 \u2014 Complete your profile so you can manage everything from one place. Step 2 (just as important) \u2014 if you have kids, add each Explorer over in the Parent Corner so every child gets their own space, progress, and saves. Step 3 \u2014 Start exploring games, lessons, art, and adventures. Step 4 \u2014 Learn and level up, earning Stars and unlocking achievements along the way!",
    pose: "idle",
    position: "top",
    scrollTo: "element",
  },
  {
    targets: ['[data-testid="testimonials-carousel"]'],
    title: "Families Love It!",
    message: "Don't just take my word for it \u2014 real families share how Isaiah's World has changed screen time into learning time. Parents and kids both love it here!",
    pose: "celebrating",
    position: "top",
    scrollTo: "element",
  },
];

export const STORAGE_KEY = "isaiah_tour_completed";
